module.exports = __webpack_public_path__ + "static/app_start-880b3a05ad83b25969115c13afd3df75.png";